// extracted by mini-css-extract-plugin
module.exports = {"csr-A":"A_csr-A__UUDlE"};